export default __webpack_public_path__ + "static/media/Bracers of Writhing.a5b3766a.jpg";